import React from 'react';
import i18n from '../../i18n';
import Button from '@material-ui/core/Button/Button';
import Card from '@material-ui/core/Card/Card';
import CardContent from '@material-ui/core/CardContent/CardContent';
import Typography from '@material-ui/core/Typography/Typography';
import Grid from '@material-ui/core/Grid/Grid';
import CardActions from '@material-ui/core/CardActions/CardActions';
import {withStyles} from '@material-ui/core/styles';
import Chip from '@material-ui/core/Chip/Chip';
import {FormattedDate} from 'react-intl';
import Icon from '@material-ui/core/Icon/Icon';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import IconButton from '@material-ui/core/IconButton/IconButton';
import Divider from '@material-ui/core/Divider/Divider';
import {Badge, Paper, Link} from '@material-ui/core';
import Table from '@material-ui/core/Table/Table';
import TableHead from '@material-ui/core/TableHead/TableHead';
import TableRow from '@material-ui/core/TableRow/TableRow';
import TableBody from '@material-ui/core/TableBody/TableBody';
import TableCell from '@material-ui/core/TableCell/TableCell';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import EllipsisWithTooltip from '../Formater/EllipsisWithTooltip';
import {getContactName} from '../Form/utils';
import PhoneLinkButton from '../Formater/PhoneLinkButton';
import TowLine from '../../components/Text/TwoLine';
import {withPaginator, Pagination} from '../../components/Pagination';
import TableRowClickable from '../Form/TableRowClickable';
import TableCellSortable, {xOrder} from '../Form/TableCellSortable';

const renderParent = (contact, classes) => {
    return contact.parent_id && contact.parent && contact.parent.id > 0 && (
        <Button href={`/contacts/${contact.contact_type}/${contact.parent.id}`} size="small">
            <Icon>format_paint</Icon>
            {getContactName(contact.parent)}
        </Button>
    );
};

const renderShow = (contact, classes) => {
    return (
        <IconButton
            component="a"
            href={`/contacts/${contact.contact_type}/${contact.id}`}
        >
            <Icon>find_in_page</Icon>
        </IconButton>
   );
};

const renderEdit = (contact, classes) => {
    if (!window.can('contacts.update')) {
        return null;
    }

    return (
    <IconButton href={`/contacts/${contact.contact_type}/${contact.id}/edit`} dusk={`edit-contact${contact.id}`}>
        <Icon>edit</Icon>
    </IconButton>
)};

const renderPhone = (number, type, classes) => (
    <PhoneLinkButton phone={number} icon={ type === 'landline'? 'phone': 'smartphone'} iconOnly={true}
                     iconButtonProps={{className: classes.iconButton}}
                     iconProps={{className: classes.iconButtonIcon}}
    />
);

const renderEmail = (contact, classes) => (
    <Tooltip placement="bottom-start" title={contact.email}
             classes={{tooltip: classes.popper}}>
        <IconButton href={`mailto:${contact.email}`}
                    className={classes.iconButton}>
            <Icon
                className={classes.iconButtonIcon}>alternate_email</Icon>
        </IconButton>
    </Tooltip>
);

class ContactGrid extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            width: window.innerWidth,
        };
    }

    updateDimensions = () => {
        this.setState({width: window.innerWidth});
    };

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    render() {
        const {items, classes, house, contactType, isTable, order, column, paramsQuery} = this.props;
        const searchDetailsColumn = (contactType === 'craft' ? 'address_number' : 'first_name');

        return (
            <section>
                {this.state.width >= 600 && isTable &&
                <Paper className={classes.paper}>
                    <div className={classes.tableWrap}>
                        <Table className={classes.list}>
                            <TableHead>
                                <TableRow>
                                    <TableCellSortable
                                        action={`/contacts/sort/${contactType}s/address_number/${order}`}
                                        active={column === 'address_number'}
                                        order={order}
                                        align={'center'}
                                        style={{width:150}}
                                    >
                                        {i18n.get('contacts.address_number')}
                                    </TableCellSortable>
                                    <TableCellSortable
                                        action={`/contacts/sort/${contactType}s/name/${order}`}
                                        active={column === 'name'}
                                        order={order}
                                        style={{width: '60%',}}
                                    >
                                        {i18n.get('contacts.table.name_type')}
                                    </TableCellSortable>
                                    <TableCell align="center">{i18n.get('contacts.contact')}</TableCell>
                                    <TableCell align="center">{i18n.get('contacts.actions')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {items && items.map(contact => {
                                    const is_company = contact.contact_type === 'craft';

                                    return (
                                        <TableRowClickable key={'contactRow'+contact.id} action={`/contacts/${contact.contact_type}/${contact.id}`}>
                                            <TableCell align="center">
                                                <Typography component={'h6'}>{contact.address_number}</Typography>
                                            </TableCell>
                                            <TableCell align="left">
                                                <Typography component="h6">
                                                    <EllipsisWithTooltip>
                                                        {getContactName(contact)}
                                                    </EllipsisWithTooltip>
                                                </Typography>
                                            </TableCell>
                                            <TableCell align="center" onClick={e => { e.stopPropagation('all'); }}>
                                                <TowLine
                                                    main={
                                                        <React.Fragment>
                                                            {contact.email && renderEmail(contact, classes)}
                                                            {contact.landline && renderPhone(contact.landline,'landline', classes)}
                                                            {contact.mobile && renderPhone(contact.mobile,'mobile', classes)}
                                                        </React.Fragment>
                                                    }
                                                />
                                            </TableCell>
                                            <TableCell align="center" onClick={e => { e.stopPropagation('all'); }}>
                                                {renderShow(contact,classes)}
                                                {renderEdit(contact, classes)}
                                                {renderParent(contact, classes)}
                                            </TableCell>
                                        </TableRowClickable>
                                    );
                                })}
                                </TableBody>
                        </Table>
                        <Pagination colSpan={1} table={false}/>
                    </div>
                </Paper>
                }

                {(this.state.width < 600 || !isTable) &&
                <Grid container spacing={16}>
                    {items && items.map(contact => {
                        contact.is_craft = contact.contact_type === 'craft';

                        let fullname = getContactName(contact);

                        return (
                            <Grid item xs={12} sm={12} md={6} lg={4} xl={3} key={contact.id}>
                                <Card>
                                    <CardContent className={classes.cardContent}>
                                        <Link href={`/contacts/${contact.contact_type}/${contact.id}`}>

                                            <Grid container spacing={8} justify="space-between" alignItems="center">
                                                {/*<Grid item xs={12} sm={contact.is_craft && contact.department ? 7 : 12} style={{float: 'right'}}>*/}
                                                <Grid item xs={12}>
                                                    <Typography variant="h6">
                                                        {fullname}
                                                    </Typography>
                                                </Grid>
                                            </Grid>

                                            {contact.first_name && contact.last_name && (
                                                <Typography variant="subtitle1">
                                                    {`${contact.first_name} ${contact.last_name}`}
                                                </Typography>
                                            )}

                                            {contact.street && (
                                                <Typography>
                                                <span>
                                                    {contact.street} {contact.number || ''} <br/>
                                                    {contact.zip || ''} {contact.city || ''}
                                                </span>
                                                </Typography>
                                            )}
                                        </Link>
                                        <Grid item xs={12} style={{height:'100%'}}>
                                            <Grid container direction={'row'} justify={'flex-end'} alignItems={"flex-end"} tyle={{height:'100%'}}>
                                                <Grid item>
                                                    {contact.is_craft && contact.department && (
                                                        <Chip color="primary" variant="outlined"
                                                              label={contact.department}
                                                              classes={{
                                                                  root: classes.chip,
                                                                  label: classes.chipLabel,
                                                              }}/>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </CardContent>

                                    <Divider/>

                                    <CardActions className={classes.cardActions}>
                                        <Grid container justify="space-between" alignItems="center">
                                            <Grid item>
                                                {contact.email && renderEmail(contact, classes)}
                                                {contact.landline && renderPhone(contact.landline,'landline', classes)}
                                                {contact.mobile && renderPhone(contact.mobile,'mobile', classes)}
                                            </Grid>

                                            <Grid item>
                                                {renderParent(contact, classes)}
                                                {renderEdit(contact, classes)}
                                            </Grid>
                                        </Grid>
                                    </CardActions>
                                </Card>
                            </Grid>
                        );
                    })}
                    <Pagination colSpan={1} table={false}/>
                </Grid>
                }
            </section>
        );
    }
}

const styles = theme => ({
    tableWrap: {
        overflowX: 'auto',
    },
    cardContent: {
        position: 'relative',
        minHeight: '150px',
        height:'100%',
    },
    cardActions: {
        padding: '4px 8px',
    },
    chip: {
        height: '24px',
    },
    chipLabel: {
        padding: '0 8px',
    },
    iconButton: {
        fontSize: 12,
        padding: '8px',
        opacity: 0.5,

        '&:hover': {
            color: theme.colors.primary,
            opacity: 1,
        },
    },
    iconButtonIcon: {
        fontSize: 20,
    },
    popper: {
        fontSize: 14,
        boxShadow: '2px 2px 3px rgba(0,0,0,0.3)',
    },
    houseLink: {
        borderRadius: 2,
        backgroundColor: '#fff',
        textTransform: 'none',
        padding: '2px 18px',
    },
    landlordBadge: {
        position: 'absolute',
        width: 'auto',
        padding: '1px 4px',
        top: '6px',
        right: '6px',
        backgroundColor: '#0091ea',
        color: '#fff',
        borderRadius: 2,
    },
    flexDisplay: {
        display: 'flex',
        justifyContent: 'start',
    },
    landlordBadgeT: {
        width: 'auto',
        padding: '1px 4px',
        backgroundColor: '#0091ea',
        color: '#fff',
        borderRadius: 2,
    },
    paper: {
        marginTop: theme.spacing.unit * 3,
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginTop: theme.spacing.unit * 6,
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
    list: {

        "& tr": {
            height:40,
        },
        "& td" : {
            paddingTop:0,
            paddingBottom:0,
        },
        "& a": {
            padding:2,
        }
    }
});

export default withStyles(styles)(
    withPaginator('contacts')(ContactGrid),
);
